/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Judge } from '../models/Judge';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class JudgesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get a judge
     * @param workspaceId
     * @param projectId
     * @param id
     * @returns any Successful request
     * @throws ApiError
     */
    public judgesGet(
        workspaceId: string,
        projectId: string,
        id: string,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Judge;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/judges/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update a judge
     * @param workspaceId
     * @param projectId
     * @param id
     * @param requestBody The judge properties to update
     * @returns any Successful request
     * @throws ApiError
     */
    public judgesPut(
        workspaceId: string,
        projectId: string,
        id: string,
        requestBody: {
            /**
             * Slug to uniquely reference the judge within the project
             */
            slug: string;
            /**
             * Guidelines of the LLM judge
             */
            guidelines: string | null;
            /**
             * Context of the LLM judge, all additional information related to the domain the judge operates in.
             */
            context: string | null;
            /**
             * Name of the LLM judge
             */
            name: string;
            /**
             * Domains the LLM judge is operating in
             */
            domains: Array<string>;
            /**
             * Description of the LLM judge
             */
            description: string;
            /**
             * The LLM model used by this LLM judge
             */
            model: '@hf/mistral/mistral-7b-instruct-v0.2' | '@cf/meta/llama-3.3-70b-instruct-fp8-fast';
            /**
             * The few-shot examples used with the judge
             */
            shots: Array<string>;
            status: 'draft' | 'published' | 'archived';
            ownerId: string;
            /**
             * Description of the change
             */
            changeDescription?: string | null;
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Judge;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/judges/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update the fields of a judge
     * @param workspaceId
     * @param projectId
     * @param id
     * @param requestBody The judge properties to update
     * @returns any Successful request
     * @throws ApiError
     */
    public judgesPatch(
        workspaceId: string,
        projectId: string,
        id: string,
        requestBody: {
            /**
             * Slug to uniquely reference the judge within the project
             */
            slug?: string;
            /**
             * Guidelines of the LLM judge
             */
            guidelines?: string | null;
            /**
             * Context of the LLM judge, all additional information related to the domain the judge operates in.
             */
            context?: string | null;
            /**
             * Name of the LLM judge
             */
            name?: string;
            /**
             * Domains the LLM judge is operating in
             */
            domains?: Array<string>;
            /**
             * Description of the LLM judge
             */
            description?: string;
            /**
             * The LLM model used by this LLM judge
             */
            model?: '@hf/mistral/mistral-7b-instruct-v0.2' | '@cf/meta/llama-3.3-70b-instruct-fp8-fast';
            /**
             * The few-shot examples used with the judge
             */
            shots?: Array<string>;
            status?: 'draft' | 'published' | 'archived';
            ownerId?: string;
            /**
             * Description of the change
             */
            changeDescription?: string | null;
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Judge;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/judges/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Delete a judge
     * @param workspaceId
     * @param projectId
     * @param id
     * @returns any Successful request
     * @throws ApiError
     */
    public judgesDel(
        workspaceId: string,
        projectId: string,
        id: string,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: {
            /**
             * ID of the judge
             */
            id: string;
            _object: 'judge';
        };
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/judges/{workspaceId}/{projectId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * List judges
     * @param workspaceId
     * @param projectId
     * @param orderBy
     * @param perPage
     * @param page
     * @param order
     * @param name
     * @param model
     * @param description
     * @param visibility
     * @param slug
     * @param guidelines
     * @param context
     * @param createdBy
     * @param ownerId
     * @param lastEditedBy
     * @param status
     * @param versionId
     * @param lastActive
     * @returns any Successful request
     * @throws ApiError
     */
    public judgesList(
        workspaceId: string,
        projectId: string,
        orderBy: 'id' | 'name' | 'model' | 'description' | 'visibility' | 'slug' | 'guidelines' | 'context' | 'createdBy' | 'ownerId' | 'lastEditedBy' | 'status' | 'versionId' | 'lastActive' | 'created' | 'updated' = 'created',
        perPage: string = '20',
        page: string = '1',
        order: 'asc' | 'desc' = 'desc',
        name?: (string | Array<string>),
        model?: (string | Array<string>),
        description?: (string | Array<string>),
        visibility?: (string | Array<string>),
        slug?: (string | Array<string>),
        guidelines?: (string | Array<string>),
        context?: (string | Array<string>),
        createdBy?: (string | Array<string>),
        ownerId?: (string | Array<string>),
        lastEditedBy?: (string | Array<string>),
        status?: (string | Array<string>),
        versionId?: (string | Array<string>),
        lastActive?: (string | Array<string>),
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Array<Judge>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/judges/{workspaceId}/{projectId}',
            path: {
                'workspaceId': workspaceId,
                'projectId': projectId,
            },
            query: {
                'orderBy': orderBy,
                'perPage': perPage,
                'page': page,
                'order': order,
                'name': name,
                'model': model,
                'description': description,
                'visibility': visibility,
                'slug': slug,
                'guidelines': guidelines,
                'context': context,
                'createdBy': createdBy,
                'ownerId': ownerId,
                'lastEditedBy': lastEditedBy,
                'status': status,
                'versionId': versionId,
                'lastActive': lastActive,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Create a new judge
     * @param requestBody The judge to create
     * @returns any Resource created
     * @throws ApiError
     */
    public judgesPost(
        requestBody: {
            /**
             * ID of the workspace
             */
            workspaceId: string;
            /**
             * ID of the project
             */
            projectId: string;
            /**
             * Slug to uniquely reference the judge within the project
             */
            slug: string;
            /**
             * Guidelines of the LLM judge
             */
            guidelines: string | null;
            /**
             * Context of the LLM judge, all additional information related to the domain the judge operates in.
             */
            context: string | null;
            /**
             * Name of the LLM judge
             */
            name: string;
            /**
             * Domains the LLM judge is operating in
             */
            domains: Array<string>;
            /**
             * Description of the LLM judge
             */
            description: string;
            /**
             * The LLM model used by this LLM judge
             */
            model: '@hf/mistral/mistral-7b-instruct-v0.2' | '@cf/meta/llama-3.3-70b-instruct-fp8-fast';
            /**
             * The few-shot examples used with the judge
             */
            shots: Array<string>;
        },
    ): CancelablePromise<{
        message: {
            message: 'Resource created';
        };
        success: boolean;
        error: any;
        result: Judge;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/judges/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Generate a new judge from a prompt
     * @param requestBody Description of the judge to generate
     * @returns any Resource created
     * @throws ApiError
     */
    public judgesGenerate(
        requestBody: {
            /**
             * ID of the workspace
             */
            workspaceId: string;
            /**
             * ID of the project
             */
            projectId: string;
            /**
             * Name of the LLM judge
             */
            name: string;
            /**
             * Domains the LLM judge is operating in
             */
            domains: Array<string>;
            /**
             * Description of the LLM judge
             */
            prompt: string;
            /**
             * The LLM model used by this LLM judge
             */
            model: '@hf/mistral/mistral-7b-instruct-v0.2' | '@cf/meta/llama-3.3-70b-instruct-fp8-fast';
        },
    ): CancelablePromise<{
        message: {
            message: 'Resource created';
        };
        success: boolean;
        error: any;
        result: Judge;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/judges/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
